import { z } from "zod"
import { booleanRequired } from "@/models/common"
import { BetterDocConsultationReasonValues } from "@/types/__generated__/union-types"

export const betterDocSearchBaseSchema = z.object({
  transferDataConsent: booleanRequired,
  reasonForConsultations: z.enum(BetterDocConsultationReasonValues, {
    error: "common.fieldErrorList.requiredField",
  }),
})

export type BetterDocSearchBaseFormType = z.infer<typeof betterDocSearchBaseSchema>
